export const document = {
  type: "type",
  status: "status"
};
